/*!

=========================================================
* Material Dashboard React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

// core components
import Admin from "layouts/Admin.js";
import Login from "layouts/Login.js";
import Terms from "layouts/Terms.js";

import "assets/css/material-dashboard-react.css?v=1.9.0";

import adminService from "services/admin.service";

const hist = createBrowserHistory();

const isLocalDevelopment =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

async function getCookie(name) {
  const cookie = await adminService.getControl();
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2 && parts.pop().split(';').shift() === cookie)
    return true
  else
    return false
}


const resolveCookieVerification = isLocalDevelopment
	? Promise.resolve(true)
	: getCookie('_control_cookie');

resolveCookieVerification.then(cookie_verify => {
  ReactDOM.render(
    <Router history={hist}>
      <Switch>
        {cookie_verify === false ? <Route path="/login" component={Login} /> : <Route path="/admin" component={Admin} /> }
        {cookie_verify === false ? <Route path="/terms" component={Terms} /> : <Route path="/terms" component={Admin} /> }
        {cookie_verify === false ? <Redirect from="/" to="/login" /> : <Redirect from="/" to="/admin/alunos/gerenciar" /> }
      </Switch>
    </Router>,
    document.getElementById("root")
  );
})